import React from "react";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import DragAndDropImage from "components/MainApp/atoms/Forms/DragAndDropImage";
import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import Toggle from "components/MainApp/atoms/Forms/Toggle";
import Icon from "components/MainApp/atoms/Icon/icon";
import permisos from "./permisos";
import CredentialBoxes from "../CredentialsBoxes";

import styles from "./AppEdit.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const AppEdit = ({
  app,
  handleChange,
  errors,
  handleChangeImage,
  handleDeleteImage,
  handleSelect,
  handleChangeEnabled,
}) => {
  return (
    <div className={styles["app-edit-container"]}>
      <div className={styles["left"]}>
        <div className={styles["group"]}>
          <div className={styles["title"]}>{i18n.t("enter.data")}</div>
          <div className={styles["inputs"]}>
            <MainInput
              label={i18n.t("app.name")}
              required={true}
              id={"app-name"}
              name="name"
              value={app.name}
              handleChange={handleChange}
              error={errors["name"]}
            // disabled
            />
            <MainInput
              label={"Callback URL"}
              required={true}
              id={"app-callback_url"}
              name="callback_url"
              value={app.callback_url}
              handleChange={handleChange}
              error={errors["callback_url"]}
            // disabled
            />
          </div>
        </div>
        <div className={styles["group"]}>
          <div className={styles["title"]}>{i18n.t("define.permission.levels")}</div>
          <table className={styles["permisos"]}>
            <thead>
              <tr>
                <th className={styles["scope-th"]}>{i18n.t("scopes")}</th>
                <th>{i18n.t("read")}</th>
                <th>{i18n.t("create").toUpperCase()}</th>
                <th>{i18n.t("update")}</th>
              </tr>
            </thead>
            <tbody>
              {permisos.map((permiso) => {
                return (
                  <tr key={permiso.id} className={styles["permiso-wrapper"]}>
                    <td className={styles["left"]}>
                      <p className={styles["title-table"]}>{permiso.name}</p>
                    </td>
                    <td className={styles["option"]}>
                      <Checkbox
                        handleChange={() => handleSelect(`${permiso.id}_read`)}
                        checked={app.scopes.includes(`${permiso.id}_read`)}
                      ></Checkbox>
                    </td>
                    <td className={styles["option"]}>
                      <Checkbox
                        handleChange={() =>
                          handleSelect(`${permiso.id}_create`)
                        }
                        checked={app.scopes.includes(`${permiso.id}_create`)}
                      ></Checkbox>
                    </td>
                    <td className={styles["option"]}>
                      <Checkbox
                        handleChange={() =>
                          handleSelect(`${permiso.id}_update`)
                        }
                        checked={app.scopes.includes(`${permiso.id}_update`)}
                      ></Checkbox>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className={styles["right"]}>
        <div className={`${styles["group"]} ${styles["logo"]}`}>
          <div className={styles["title"]}>{capitalize(i18n.t("logo"))}</div>
          <div className={styles["image-input"]}>
            <DragAndDropImage
              name="logo"
              handleChange={handleChangeImage}
              handleDelete={handleDeleteImage}
              file={app.logo}
              error={errors.logo}
            />
          </div>
        </div>
        <div className={`${styles["group"]} ${styles["void"]}`}>
          <div className={styles["enable-toggle"]}>
            <p className={styles["toggle-label"]}>{i18n.t("app.enabled")}</p>
            <Toggle
              handleChange={handleChangeEnabled}
              checked={app.enabled}
            ></Toggle>
          </div>
        </div>
        <div className={`${styles["group"]} ${styles["void"]} ${styles["credentials"]}`}>
          <div className={styles["title"]}>{i18n.t("production.credentials")}</div>
          <CredentialBoxes app={app} />
        </div>
      </div>
    </div>
  );
};

export default AppEdit;
